
export const FETCH_RESPONDENTS = 'FETCH_RESPONDENTS';
export const SET_RESPONDENT_DATES = 'SET_RESPONDENT_DATES';